// 路由文件
import Vue from 'vue'
import Router from 'vue-router'
import store from './store/index'
// 导入 vue 和 vue-router  相当于
// <script src="vue.js">  <script src="vue-router.js">

// 添加路由规则
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

// 暴露
const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/IDCardCollection'
    }, // 重定向
    {
      path: '/addSocial2',
      component: () => import('./views/addSocial2.vue'),
      meta: {
        keepAlive: true // 需要缓存
      }
    },
    {
      path: '/addCommercial2',
      component: () => import('./views/addCommercial2.vue'),
      meta: {
        keepAlive: true // 需要缓存
      }
    },
    {
      path: '/socialProject',
      component: () => import('./views/socialProject.vue')
    },
    {
      path: '/commercialProject',
      component: () => import('./views/commercialProject.vue'),
      meta: {
        keepAlive: true // 需要缓存
      }
    },
    {
      path: '/commercialProjectA',
      component: () => import('./views/commercialProjectA.vue')
    },
    {
      path: '/commercialProjectAdd',
      component: () => import('./views/commercialProjectAdd.vue')
    },
    {
      path: '/commercialPdf',
      component: () => import('./views/commercialPdf.vue')
    },
    {
      path: '/IDCardCollection',
      component: () => import('./views/IDCardCollection.vue')
    },
    {
      path: '/bankCardVerification',
      component: () => import('./views/bankCardVerification.vue')
    },
  ]
})

router.onError((error) => {
  console.log('error===' + error)
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  const pattern2 = /Loading chunk chunk-(.*)+ failed/g
  const isChunkLoadFailed2 = error.message.match(pattern2)
  console.log('isChunkLoadFailed==' + isChunkLoadFailed)
  console.log('isChunkLoadFailed2==' + isChunkLoadFailed2)
  if (isChunkLoadFailed || isChunkLoadFailed2) {
    // 用路由的replace方法，并没有相当于F5刷新页面，失败的js文件并没有从新请求，会导致一直尝试replace页面导致死循环，而用 location.reload 方法，相当于触发F5刷新页面，虽然用户体验上来说会有刷新加载察觉，但不会导致页面卡死及死循环，从而曲线救国解决该问题
    // router.replace(targetPath)
    const targetPath = router.history.pending.fullPath
    console.log('targetPath==' + targetPath)
    if (targetPath) {
      // router.replace(targetPath)
      window.location.href = window.location.origin + '/#' + targetPath
      location.reload()
    } else {
      location.reload()
    }
  }
})

router.onReady(vm => {
  try {
    let LoadingChunkPath = window.sessionStorage.getItem('LoadingChunkPath')

    const path = vm.path
    if (LoadingChunkPath) {
      if (path !== LoadingChunkPath && path !== '/') {
        window.sessionStorage.setItem('LoadingChunkPath', vm.path)
        router.replace(vm.path)
      } else {
        router.replace(LoadingChunkPath)
      }
    }
  } catch (e) {
    console.log(e)
  }
})

// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
  // to: Route: 即将要进入的目标 路由对象
  // from: Route: 当前导航正要离开的路由  /^\-[1-9][0-9]*$/
  // next: Function: 一定要调用该方法来 resolve 这个钩子。执行效果依赖 next 方法的调用参数。
  // var patt = /Verification[0-9]{1}/
  // var reg1 = new RegExp('/verification[0-9]{1}')
  // if (to.path === '/login' || reg1.test(to.path)) return next()
  // const tokenStr = store.state.token
  // if (!tokenStr) return next('/login')
  // console.log(";;;")
  next()
})

export default router
